import React, { useEffect, useState } from "react";
import { useToggleClick } from './Menu';
import logo from './logo.png';
import pin from './pin.png';
import { Helmet } from "react-helmet";

const Header = () => {
  const handleToggleClick = useToggleClick();
  const [logo, setLogo] = useState('');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    loadLogo();
    
    // Add scroll event listener
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 0);
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
 }, []);


 const loadLogo=()=>{
  fetch("https://api.novetheitaliankitchen.in/index.php/Api/logo", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => res.json())
      .then((result) => {
        //console.log(result);
        if (result.data != "") {
          const data = result.data;
          setLogo(data);
        }
      })
    .catch((err) => {
      console.log(err.message);
    });
}

    return (
      <>
    <Helmet>

      <title>{logo.title}</title>
      <link id="favicon" rel="icon" href={logo.image} type="image/x-icon"/>
      <meta
        name="description"
        content="Discover the essence of Nove - The Italian Kitchen - where flavors come alive. Explore our menu for a culinary journey like no other. Indulge today!"
      />
      <meta
        name="keywords"
        content="Nove - The Italian Kitchen"
      />

    </Helmet>       
    <header className="main_header" id="Header" style={{position: 'fixed', top: 0, left: 0, right: 0, zIndex: 99999, backgroundColor: '#2B3215'}}>
      <div className="main-header" style={{backgroundColor: '#2B3215', width: '100%', minHeight: '70px'}}>
        <div className="container">
          {/* <div className="top-header">
            <div className="location">
              <img src={pin} alt="location" />
              <span>2900 Lapeer Rd, Port Hurons, MI 49070</span>
            </div>
            <div className="call-now">
              <span>
                Call Now: <a href="tel:+917337557853">7337557853</a>
              </span>
            </div>
          </div> */}
          <div className="bottom-header">
            <div className="logo-cont">
            <a href="/"> <img src={logo.image} alt="logo" /></a>
            </div>
            {/* <ul className="main-menu">
              <li>
                <a href="/">Home</a>
              </li>

              <li>
                <a href="/menu">Menu</a>
              </li>

            </ul> */}
            <div className="toogle-bar">
            <div className="delivery-partners">
              <ul>
                <li><a href="/feedback">Feedback</a></li>
                {/* <li><a href="#"><img src={dineout} alt="Zomato"></img></a></li> */}
              </ul>
            </div>

              <div id="toggleNav" onClick={handleToggleClick}>
                <span className="MenuBtn">
                  <i />
                  <i />
                  <i />
                </span>
              </div>
              <div id="megaMenu" className="menuNavigation" style={{}}>
                <div className="container">
                  <ul className="listItems">
                    {/* <li>
                      <a href="/">Home</a>
                    </li>

                    <li>
                      <a href="/menu">Menu</a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    </>
    );
  };
  export default Header;
